import { authClient } from './api/client'; // ou apiClient, dependendo de como está no seu código

export const UserService = {
    async fetchAndValidateUser(identifier: string): Promise<any> {
        try {
            const response = await authClient.get('/Usuario', {
                params: { q: identifier }
            });

            const user = Array.isArray(response.data) ? response.data[0] : response.data;

            if (!user || user.excluido || user.status === 'inactive') {
                throw new Error('Acesso negado: Este usuário foi removido ou está inativo.');
            }

            // Agora o user.empresa vai pegar o UUID perfeitamente!
            const secureTenantId = user.empresa || user.tenantId || user.login;

            localStorage.setItem('tenantId', secureTenantId);
            localStorage.setItem('userCode', user.login || identifier);
            localStorage.setItem('userData', JSON.stringify(user));
            localStorage.setItem('lastActivity', Date.now().toString());

            return user;
        } catch (error: any) {
            const message = error.response?.data?.error || error.message || 'Erro ao validar usuário';
            throw new Error(message);
        }
    },

    logout() {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
    }
};
